import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", path: "/" },
  { label: "全部动漫", path: "/categories" },
  { label: "番剧资讯", path: "/articles" },
  { label: "关于我们", path: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/80 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex items-center justify-between px-4 md:px-6 py-3">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-lg font-heading text-lg ${
              scrolled ? "bg-primary-500 text-background-50" : "bg-primary-500/90 text-background-50"
            }`}
          >
            漫
          </span>
          <span
            className={`font-heading text-xl md:text-2xl tracking-wide ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            动漫网
          </span>
        </Link>

        <ul className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                end={item.path === "/"}
                className={({ isActive }) =>
                  `whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                    scrolled ? "text-foreground-700" : "text-background-50"
                  } ${
                    isActive
                      ? scrolled
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-50/20 text-background-50"
                      : scrolled
                        ? "hover:bg-background-100"
                        : "hover:bg-background-50/15"
                  }`
                }
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <Link
            to="/categories"
            className="hidden md:inline-flex items-center gap-2 whitespace-nowrap rounded-full px-5 py-2 text-sm font-semibold transition-colors hover:bg-primary-600 bg-primary-500 text-background-50"
          >
            <i className="ri-search-line text-sm"></i>
            检索入口
          </Link>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
            className={`md:hidden flex h-10 w-10 items-center justify-center rounded-lg text-xl ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            <i className={open ? "ri-close-line" : "ri-menu-line"}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="md:hidden border-t border-background-200/80 bg-background-50/95 backdrop-blur px-4 py-3">
          <ul className="flex flex-col gap-1">
            {navItems.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  end={item.path === "/"}
                  className={({ isActive }) =>
                    `block rounded-lg px-4 py-3 text-sm font-medium ${
                      isActive ? "bg-primary-500 text-background-50" : "text-foreground-800 hover:bg-background-100"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}